
import { FaLinkedin } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

import Sp1 from '../assets/image/acrfi.png';

export const Footer = ({ setHashAccess }) => {
    const navigate = useNavigate();

    const handleDoubleClick = () => {
        const code = prompt("🔒 Enter access code:");
        if (code === "6590") {
            localStorage.setItem('acrfiAccess', 'true');
            localStorage.setItem('acrfiAccessTime', Date.now().toString());
            setHashAccess(true);
            navigate('/Admin');
        } else {
            setHashAccess(false);
            alert("❌ Incorrect code!");
        }
    };

    return (
        <div className='  text-[#cfcdcd] text-lg bg-[#1f2a46] pt-16 mt-16 '>
            <div className=' px-10 pb-24'>
                <div className='flex sm:flex-row flex-col'>
                    <div className="flex-grow lg:w-1/3 sm:w-full pr-24">
                        <div className='text-[#87ceeb] font-bold text-2xl'>ABOUT ACRFI</div>
                        <div className='mt-5 '>
                            ACRFI is a non profit and charitable organization striving to restore the image of God on mankind by assisting and bringing hope to at risk children, generally called "street kids"in USA and in the Congo DRC.

                        </div>

                        <div className='mt-5 flex flex-col'>
                            <span> Address :</span>
                            <span>
                                ACRFI, is a nonprofit organization incorporated in the State of Florida, US and legally operating in Miami Florida, and in 3 States of the Democratic Republic of Congo (KATANGA, KASAI & KINSHASA States).
                            </span>
                        </div>

                        <div className='mt-3 flex justify-between  xl:flex-row flex-col'>
                            <span> Email </span>
                            <span className='text-blue-400'>: Admin@theacrfi.org</span>
                        </div>

                        <div className='mt-2 flex flex-col '>
                            <div className='flex justify-between  xl:flex-row flex-col'> <span>Phone for USA</span> <span className='text-blue-400'>: +1 305-305-3055</span></div>
                            <div className='flex justify-between  xl:flex-row flex-col'> <span>Alternate for USA </span><span className='text-blue-400'>: +1 305 607 2284</span></div>
                        </div>

                        <div className='mt-5 flex flex-col'>
                            <div className='flex justify-between  xl:flex-row flex-col'><span> Phone for Congo-Katanga</span> <span className='text-blue-400'>: + 243-99-873-7019</span></div>
                        </div>

                        <div className='mt-5 flex flex-col'>
                            <div className='flex justify-between  xl:flex-row flex-col'><span> Phone for Congo-Kasai</span> <span className='text-blue-400'>: + 243-99-000-0928</span></div>
                        </div>

                        <div className='mt-5 flex flex-col'>
                            <div className='flex justify-between  xl:flex-row flex-col'><span> Phone for Congo-Kinshasa</span> <span className='text-blue-400'>: + 243-81-000-0929</span></div>
                        </div>
                    </div>

                    <div className="flex-grow lg:w-1/3 sm:w-full">
                        <div className='text-[#87ceeb] font-bold text-2xl'>QUICK LINKS</div>
                        <div className='flex flex-col gap-7 mt-5 font-bold text-2xl'>
                            <span className='cursor-pointer hover:underline hover:text-blue-400' onClick={() => { navigate('/') }}>Home</span>

                            <span className='cursor-pointer hover:underline hover:text-blue-400' onClick={() => { navigate('/Location') }}>Locations</span>

                            <span className='cursor-pointer hover:underline hover:text-blue-400' onClick={() => { navigate('/Contact') }}>Contact Us</span>

                            <span className='cursor-pointer hover:underline hover:text-blue-400' onClick={() => { navigate('/Sponsor') }}>Sponsor a child</span>

                            <span className='cursor-pointer hover:underline hover:text-blue-400' onClick={() => { navigate('/Education') }}>Education</span>

                            <span className='cursor-pointer hover:underline hover:text-blue-400' onClick={() => { navigate('/Donate') }}>Donate today</span>

                            <span className='cursor-pointer hover:underline hover:text-blue-400' onClick={() => { navigate('/about') }}>About Us</span>

                            <span className='cursor-pointer hover:underline hover:text-blue-400' onClick={() => { navigate('/News') }}>What's New</span>

                        </div>
                    </div>

                    <div className="flex-grow lg:w-1/3 sm:w-full">
                        <div className='text-[#87ceeb] font-bold text-2xl'>SUBSCRIBE TO NEWSLETTER</div>
                        <div className="mt-5">
                            <input className="block w-full rounded-md border-0 h-14 p-2 focus:outline-none text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#87ceeb] text-sm sm:text-2xl sm:leading-6" id="First Name" type="text" placeholder="First Name" />
                        </div>
                        <div className="mt-5">
                            <input className="block w-full rounded-md border-0 h-14 p-2 focus:outline-none text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#87ceeb] text-sm sm:text-2xl sm:leading-6" id="Last name" type="text" placeholder="Last Name" />
                        </div>
                        <div className="mt-5">
                            <input className="block w-full rounded-md border-0 h-14 p-2 focus:outline-none text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#87ceeb] text-sm sm:text-2xl sm:leading-6" id="Email" type="text" placeholder="Email" />
                        </div>
                        <div className='flex items-center w-full mt-3 z-0'>
                            <button className="text-red hover:before:bg-redborder-[#87ceeb] relative h-[50px] w-full overflow-hidden border border-[#87ceeb] bg-white px-3 text-[#87ceeb] shadow-2xl transition-all before:absolute before:bottom-0 before:left-0 before:top-0 before:z-0 before:h-full before:w-0 before:bg-[#87ceeb] before:transition-all before:duration-500 hover:text-white hover:shadow-[#87ceeb] hover:before:left-0 hover:before:w-full">
                                <span className="relative z-10">COMMING SSON</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className=' bg-white text-center flex justify-center gap-10 italic text-blue-400 h-14'>
                <img src={Sp1} alt="Sp1" className='max-h-full cursor-pointer' onDoubleClick={handleDoubleClick} />
                <span className='font-bold text-5xl'>A</span>
                <span className='font-bold text-5xl'>C</span>
                <span className='font-bold text-5xl'>R</span>
                <span className='font-bold text-5xl'>F</span>
                <span className='font-bold text-5xl'>I</span>
            </div>

            <div className=' text-center flex justify-center italic text-blue-400'>
                <div className=' flex flex-col items-center justify-center'>
                    <span>© 2011-2025 THEACRFI. All Rights Reserved. </span>
                    <div className='flex items-center sm:flex-row flex-col  gap-2'>
                        <div>Designed & built by</div>
                        <div >
                            <a href='https://cd.linkedin.com/in/shams-kibonge-5623a7260' rel="noreferrer" target='_blank' className='flex items-center gap-2 cursor-pointer'>
                                <span className='text-blue-500 underline'>Shams Kibonge.</span>
                                <span><FaLinkedin size={20} className='text-[#0068C2]' /></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}